import { FC } from 'react';
import { SummaryAlert } from 'src/presentations/components/atom/alert/Summary';
import { invoiceFinalResolutionMapper } from 'src/utils/invoiceMapper';
import { AmountInfo } from '../courier/financeDetails/AmountInfo';
import { UCTSummaryProps } from '../types';

export const MainDetailsSummary: FC<UCTSummaryProps> = ({ invoiceSummary }) => {
  const status = invoiceSummary?.status;

  if (status === 'APPROVED') {
    if (invoiceSummary?.invoiceDispute && invoiceSummary?.invoiceDispute?.agreementResolution === 'ACCEPT_INVOICE_WITH_CREDIT_NOTE') {
      return (
        <div className='p-16 xl:p-24 bg-[#28333B]'>
          <div className='p-8 xl:p-12 bg-white border border-neutral-20 rounded-20'>
            <SummaryAlert isApprove title='Invoice Approved With Credit Note' info='' />
            <div className='mt-12 p-12'>
              <AmountInfo
                title='Original Invoice Total Amount'
                total={invoiceSummary?.invoiceAmount?.afterTax}
                currency={invoiceSummary?.invoiceAmount?.currency}
              />
              <AmountInfo
                title='Expected Credit Note Total Amount'
                total={invoiceSummary?.invoiceDispute?.expectedTotalAmount?.afterTax}
                currency={invoiceSummary?.invoiceDispute?.expectedTotalAmount?.currency}
                isCredit
              />
              <AmountInfo
                title='Total Amount to be Paid'
                total={invoiceSummary?.amountToBePaid?.afterTax}
                currency={invoiceSummary?.amountToBePaid?.currency}
                isTotal
                isLast
              />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className='p-16 xl:p-24 bg-[#28333B]'>
        <div className='p-8 xl:p-12 bg-white border border-neutral-20 rounded-20'>
          <SummaryAlert isApprove title='Invoice Approved' info='' />
          <div className='mt-12 p-12'>
            <AmountInfo
              title='Total Amount to be Paid'
              total={invoiceSummary?.amountToBePaid?.afterTax}
              beforeTaxValue={invoiceSummary?.amountToBePaid?.beforeTax}
              currency={invoiceSummary?.amountToBePaid?.currency}
              isLast
            />
          </div>
        </div>
      </div>
    );
  }

  if (status === 'REJECTED') {
    return (
      <div className='p-16 xl:p-24 bg-[#28333B]'>
        <div className='p-8 xl:p-12 bg-white border border-neutral-20 rounded-20'>
          <SummaryAlert title={invoiceFinalResolutionMapper(invoiceSummary?.finalResolution)} info='' />
        </div>
      </div>
    );
  }

  return null;
};
